import { css, rem, styled, theme } from 'design-system';

const Wrapper = styled('div', {
  textAlign: 'center',
  width: '47%',
});

const atwork = css({
  padding: '20px',
  borderRadius: '5px',
  display: 'flex',
  flexWrap: 'wrap-reverse',
});

const language = css({
  border: `1px solid ${theme.colors.gray8}`,
  padding: '20px',
  borderRadius: '5px',
  background: theme.colors.gray5,
  display: 'flex',
  flexWrap: 'wrap-reverse',
  zIndex: 0,
});

const technical = css({
  border: `1px solid ${theme.colors.yellow6}`,
  padding: '20px',
  borderRadius: '5px',
  background: theme.colors.yellow2,
  display: 'flex',
  flexWrap: 'wrap-reverse',
});

const ai = css({
  border: `1px solid ${theme.colors.yellow6}`,
  padding: '20px',
  borderRadius: '5px',
  background: theme.colors.yellow2,
  display: 'flex',
  flexWrap: 'inherit',
});

const edited = css({
  border: `1px solid ${theme.colors.gray8}`,
  padding: '20px',
  borderRadius: '5px',
  background: theme.colors.gray5,
  display: 'flex',
  flexWrap: 'inherit',
});

const def = css({
  width: '100%',
});

const head = css({
  color: theme.colors.blue12,
  fontSize: rem(24),
  fontWeight: '600',
  lineHeight: '36px',
  textAlign: 'left',
});

const info = css({
  color: 'rgba(0, 1, 3, 1)',
  fontSize: rem(16),
  lineHeight: '24px',
  marginTop: '10px',
  textAlign: 'left',
});

const headv1 = css({
  color: 'rgba(5, 30, 87, 1)',
  fontSize: '22px',
  fontWeight: '700',
  lineHeight: '32px',
  textAlign: 'left',
});

const infov1 = css({
  color: 'rgba(5, 30, 87, 1)',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  marginTop: '10px',
  textAlign: 'left',
  width: '260px',
});

const infoSection = css({
  width: '100%',
});

const imageSection = css({
  minHeight: '220px',
  width: '100%',
  position: 'relative',
});

const imgLangMainEnd = css({
  width: '100%',
  right: '-20px',
  bottom: '-60px',
  position: 'absolute',
  zIndex: -1,
});

const imgTechMainStart = css({
  width: '100%',
  left: '-20px',
  top: '-20px',
  position: 'absolute',
});

const imgAIPoweredMainStart = css({
  width: '100%',
  right: '-20px',
  bottom: '-20px',
  position: 'absolute',
});

const imgEditedEnd = css({
  width: '100%',
  height: '70%',
  right: '-20px',
  bottom: '-20px',
  position: 'absolute',
});

const FloatingImage = styled('div', {
  height: 60,
  minWidth: 60,
  padding: '6px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  position: 'absolute',
});

const imgSmallLanguage = css({
  top: '18px',
  left: '-40px',
  position: 'absolute',
  backgroundColor: 'White',
  boxShadow: '0px 0px 30px #D9E1F2',
});

const imgSmallTechnical = css({
  top: '155px',
  right: '-105px',
});

const imgSmallAi = css({
  top: '55px',
  left: '-48px',
  position: 'absolute',
  backgroundColor: 'White',
  boxShadow: '0px 0px 30px #D9E1F2',
});

const imgSmallEdited = css({
  top: '-4px',
  right: '-35px',
  position: 'absolute',
  backgroundColor: 'White',
  boxShadow: '0px 0px 30px #D9E1F2',
});

const floatText = css({
  marginLeft: '5px',
});

const floatTitle = css({
  fontSize: '14px',
  lineHeight: '25px',
  textAlign: 'left',
  color: theme.colors.blue12,
});

const floatInfo = css({
  fontSize: '12px',
  lineHeight: '18px',
  textAlign: 'left',
  color: theme.colors.gray11,
});

// const floatSmallImg = css({
//   marginLeft: '10px',
// });

interface AtWorkCardProps {
  heading: string;
  content: string;
  mainImage: string;
  floatingImage?: string;
  cardType: string;
  // smallImage?: string;
  floatingTitle?: string;
  floatingInfo?: string;
  mainImageAlt?: string;
  floatingImageAlt?: string;
  contentAriaLabel?: string;
  cardAriaLabel?: string;
  version?: string;
}

export const AtWorkCard = ({
  heading,
  content,
  mainImage,
  floatingImage,
  cardType,
  // smallImage,
  floatingTitle,
  floatingInfo,
  mainImageAlt,
  floatingImageAlt,
  contentAriaLabel,
  cardAriaLabel,
  version,
}: AtWorkCardProps) => {
  if (version && version === 'v1') {
    return (
      <>
        <Wrapper
          aria-label={cardAriaLabel}
          className={atwork()}
          role="region"
          aria-labelledby={`card-heading-${heading.replace(/\s+/g, '-')}`}
          aria-describedby={`card-content-${heading.replace(/\s+/g, '-')}`}
        >
          <div className={infoSection()}>
            <img
              src={mainImage}
              alt={mainImageAlt}
              style={{ marginBottom: '10px' }}
            />
            <div
              id={`card-heading-${heading.replace(/\s+/g, '-')}`}
              className={headv1()}
            >
              {heading}
            </div>
            <div
              aria-label={contentAriaLabel}
              id={`card-content-${heading.replace(/\s+/g, '-')}`}
              className={infov1()}
            >
              {content}
            </div>
          </div>
        </Wrapper>
      </>
    );
  } else {
    return (
      <>
        <Wrapper
          aria-label={cardAriaLabel}
          className={
            cardType === 'languageCheck'
              ? language()
              : cardType === 'technicalCheck'
              ? technical()
              : cardType === 'aiPowered'
              ? ai()
              : cardType === 'editedFiles'
              ? edited()
              : def()
          }
          role="region"
          aria-labelledby={`card-heading-${heading.replace(/\s+/g, '-')}`}
          aria-describedby={`card-content-${heading.replace(/\s+/g, '-')}`}
        >
          <div className={infoSection()}>
            <div
              id={`card-heading-${heading.replace(/\s+/g, '-')}`}
              className={head()}
            >
              {heading}
            </div>
            <div
              aria-label={contentAriaLabel}
              id={`card-content-${heading.replace(/\s+/g, '-')}`}
              className={info()}
            >
              {content}
            </div>
          </div>
          <div className={imageSection()}>
            <img
              className={
                cardType === 'languageCheck'
                  ? imgLangMainEnd()
                  : cardType === 'technicalCheck'
                  ? imgTechMainStart()
                  : cardType === 'aiPowered'
                  ? imgAIPoweredMainStart()
                  : cardType === 'editedFiles'
                  ? imgEditedEnd()
                  : ''
              }
              src={mainImage}
              alt={mainImageAlt}
            />
            <FloatingImage
              className={
                cardType === 'languageCheck'
                  ? imgSmallLanguage()
                  : cardType === 'technicalCheck'
                  ? imgSmallTechnical()
                  : cardType === 'aiPowered'
                  ? imgSmallAi()
                  : cardType === 'editedFiles'
                  ? imgSmallEdited()
                  : def()
              }
            >
              {floatingImage && (
                <img src={floatingImage} alt={floatingImageAlt} />
              )}
              {/* <div className={floatSmallImg()}>
              {smallImage ? <img src={smallImage} /> : null}
            </div> */}

              {floatingTitle ? (
                <div className={floatText()}>
                  <div className={floatTitle()}>{floatingTitle}</div>
                  <div className={floatInfo()}>{floatingInfo}</div>
                </div>
              ) : null}
            </FloatingImage>
          </div>
        </Wrapper>
      </>
    );
  }
};

AtWorkCard.displayName = 'AtWorkCard';
